import { Flex } from "@chakra-ui/react";
import Text, { TextType } from "components/Text_DEPRECATED";
import BulletIcon from "lib/svgs/Bullet";

interface OwnProps {
  text: string;
}

/**
 * @deprecated
 * @param props
 * @returns
 */
export default function TextWithBullet(props: OwnProps): JSX.Element {
  return (
    <Flex flexDirection="row" justifyContent="flex-start" alignItems="center">
      <BulletIcon />
      <Text type={TextType.PARAGRAPH} marginLeft="10px">
        {props.text}
      </Text>
    </Flex>
  );
}
